<template>
  <div v-if="!isMobile" class="card-boder-bg">
    <div class="basket_insights">
      <div class="token_supply">
        <div style="display: flex; align-items: center">
          <h1>{{ $t("msg.token_supply") }}</h1>
          <img
            src="../../../assets/images/external-link.svg"
            style="width: 1.2rem; margin-left: 0.5rem; cursor: pointer"
            alt="external-link"
            @click="openSite()"
          />
        </div>

        <div class="basket_insights_content" style="align-items: end" v-if="fundTails[0].tokenQuantity > 0">
          <div style="display: flex; align-items: center">
            <img src="../../../assets/images/blue_icon.svg" alt="blue icon" />
            <span>{{ currencyFormat(fundTails[0].tokenQuantity) }} BLUE</span>
          </div>
        </div>
      </div>
      <hr />
      <div class="basket_value">
        <h1>{{ $t("msg.basket_value") }}</h1>
        <div
          class="basket_insights_content"
          style="flex-direction: column; align-items: end"
        >
          <div style="display: flex; align-items: center" v-if="fundTails[0].tokenQuantity > 0">
            <img src="../../../assets/images/coins/coin_USDT.png" alt="USDT" />
            <span>  
              {{ currencyFormat(bluValue[0].value * fundTails[0].tokenQuantity) }} USDT
            </span>
          </div>
          <p @click="toggleModalCurrencies()">
            {{ $t("msg.view_other_currencies") }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="tabs_mobile" v-else>
    <div class="tab">
      <input class="tab_input" type="checkbox" id="token_supply" />
      <label class="tab-label">
        {{ $t("msg.token_supply") }}
        <div class="basket_insights">
          <div class="token_supply" v-if="fundTails[0].tokenQuantity > 0">
            <div class="basket_insights_content">
              <img src="../../../assets/images/blue_icon.svg" alt="blue icon" />
              <span>{{ currencyFormat(fundTails[0].tokenQuantity) }} BLUE</span>
            </div>
          </div>
        </div>
      </label>

      <div class="tab-content">
        <div class="basket_insights">
          <div class="basket_value">
            <h1>{{ $t("msg.basket_value") }}</h1>
            <div class="basket_insights_content" style="align-items: center">
              <img
                src="../../../assets/images/coins/coin_USDT.png"
                alt="USDT"
              />
              <div
                style="display: flex; flex-direction: column; align-items: end"
              >
                <span v-if="fundTails[0].tokenQuantity > 0">
                  {{ currencyFormat(bluValue[0].value * fundTails[0].tokenQuantity) }} USDT
                </span>
                <p @click="toggleModalCurrencies()">
                  {{ $t("msg.view_other_currencies") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  created() {
    this.getFundTails();
    this.checkIfMobile();
  },
  mounted() {
    window.addEventListener("resize", this.checkIfMobile);
  },
  data: () => ({
    fundTails: "",
    isMobile: false,
  }),
  methods: {
    toggleModalCurrencies() {
      this.$emit("toggleModalCurrencies");
    },

    openSite() {
      window.open(
        "https://bscscan.com/token/0xE2F3Db52F7065220e113014f23f5DD4c7bafBAc2"
      );
    },

    async getFundTails() {
      let params = {
        offset: 0,
        limit: 1,
        entryType: "live",
      };
      try {
        let resp = await this.$store.dispatch("getFundTails", params);
        this.fundTails = resp.data;
      } catch (e) {
        console.log("error ", e);
      }
    },

    currencyFormat(num) {
      if (num) {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        return 0;
      }
    },

    checkIfMobile() {
      let w = window,
        x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
  },
  computed: {
    ...mapGetters(["bluValue"]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/private/insights/InsightsSupply.vue